import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiResponseCode, FileUploadType } from 'src/app/core/enums';
import { Location } from '@angular/common';
import { CustomerDetails } from 'src/app/core/models/customer-details';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AppData } from 'src/app/app.data';
import { MatDialog } from '@angular/material/dialog';
import { UploadProgressComponent } from '../../upload-progress/upload-progress.component';
import { SelectDepartmentDialogComponent } from '../../select-department-dialog/select-department-dialog.component';
import { FormsService } from 'src/app/core/services/forms.service';
import { SendFormDialogComponent } from 'src/app/dialogs/send-form-dialog/send-form-dialog.component';
import { CommonDialogComponent } from 'src/app/dialogs/common-dialog/common-dialog.component';
import { Utils } from 'src/app/core/utils';
import { UserScope } from 'src/app/core/interfaces/user-scope';
import { ScopeService } from 'src/app/core/services/scope.service';


@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss']
})
export class PatientDetailsComponent implements OnInit {

  customerID: number;
  returnURL: string;
  error: string;
  settings: Settings;
  userScope: UserScope;


  customer: CustomerDetails;
  medicalInfo: any[] = [];
  totalFutureEvents: number = 0;
  canViewPatientMedicalData: boolean = false;
  hasMedicalWarnings: boolean = false;
  uploadType: FileUploadType = FileUploadType.Undefined;
  uploadDepartmentID = '';

  @ViewChild('file', {static:false}) file: ElementRef;
  @ViewChild('fileDocument') fileDocument: ElementRef<HTMLElement>;

  constructor(
    private appSettings: AppSettings,
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private location: Location,
    private authService: AuthenticateService,
    private formService: FormsService,
    private appData: AppData,
    private dialog: MatDialog,
    private scopeService: ScopeService,
  ) {


    this.settings = appSettings.settings;
    this.canViewPatientMedicalData = authService.claims.CanViewPatientMedicalData || false;
    this.userScope = scopeService.userScope;
  }


  ngOnInit() {
    this.customerID = +this.route.snapshot.paramMap.get('id'); // the (+) sign convert string to number
    if (this.customerID > 0) {
      this.loadData(this.customerID);
    }
  }

  loadData(customerID) {
    this.customerService.getDetails(customerID).subscribe(result => {

      if (result.Code === ApiResponseCode.Success) {

        this.totalFutureEvents = result.Data.totalFutureEvents || 0;
        this.customer = new CustomerDetails(result.Data.customer);
        this.medicalInfo = result.Data.medicalInfo || [];
        this.hasMedicalWarnings = result.Data.hasMedicalWarnings;
        this.canViewPatientMedicalData = result.Data.canViewPatientMedicalData;

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }

  createAppt() {
    this.appData.customerDetails = this.customer; // save customer details in appData
    this.appData.findTimeCancelButtonRoute = 'patient-details/' + this.customer.ID; // set findtime cancel button route back to customerDetails
    this.router.navigate(['/find-time']);
  }

  back() {
    // this.router.navigate(['/search-customer']);
    this.location.back();
  }

  triggerImageUpload() { 
     // trigger onFileChange
    this.uploadType = FileUploadType.Image;
    let el: HTMLElement = this.file.nativeElement;    
    Utils.dispatchEvent(el, 'click');
  }

  

  triggerDocumentUpload(){
    // trigger onFileChange
    this.uploadType = FileUploadType.Document;
    let el: HTMLElement = this.fileDocument.nativeElement;    
    Utils.dispatchEvent(el, 'click');
  }

  triggerImageUploadWithDepartment(eventFileChange: any) { 
    if(this.userScope.departments.length == 1){      
      this.uploadDepartmentID = `${this.userScope.departments[0].ID}`;
      this.onFileChange(eventFileChange);
    }
    else{
      var dialogRef = this.openSelectDepartmentDialog();      
      dialogRef.afterClosed().subscribe(result => {
        if (result && !result.canceled) {
            this.uploadDepartmentID = result.departmentID;
            this.onFileChange(eventFileChange);
        }
        else{              
          this.clearImageFiles(eventFileChange);
        }
      });
    }
 }

 clearImageFiles(event:any){  
    this.file.nativeElement.value = '';
    event.target.files = null;
 }

 triggerDocumentUploadWithDepartment(){
  if(this.userScope.departments.length == 1){
    this.uploadDepartmentID = `${this.userScope.departments[0].ID}`;
    this.triggerDocumentUpload();
  }
  else{
    var dialogRef = this.openSelectDepartmentDialog();
    
    dialogRef.afterClosed().subscribe(result => {
      if (result && !result.canceled) {
          this.uploadDepartmentID = result.departmentID;
          this.triggerDocumentUpload();   // trigger onFileChange
      }
    });
  }
 }

  // onCaptureImageClicked(appointment) {
   
  //   try {
  //     // check permission for camera
  //     // permissions.query  can only be found in Chrome 44 and later and Firefox 43 and later.
  //     if (Utils.isMobile()) {
        
  //       var browser = <any>navigator;        
  //       browser.permissions.query({ name: 'camera' }).then(result => {
  //         console.log(result);
        
  //         if (result.state === 'denied') { //"denied" | "granted" | "prompt";
  //           // show message only when denied
        
  //           this.showDialogForEnableCameraPermission();
  //         }
  //         else {
        
  //           // trigger file upload
  //           this.triggerImageUploadWithDepartment();
  //         }
  //       })
  //     }
  //     else {
  //       // trigger file upload without checking permission - if granted the camera will open
  //       this.triggerImageUploadWithDepartment();
  //     }


  //   } catch (err) {
  //     // trigger file upload without checking permission - if granted the camera will open
  //     this.triggerImageUploadWithDepartment();
  //   }
  // }


  openSelectDepartmentDialog(){
    const dialogRef = this.dialog.open(SelectDepartmentDialogComponent, {
      width: '300px',
      direction: (this.settings.rtl ? 'rtl' : null),
      disableClose: true,
      data: {
        caller: 'patientDetails'
      }
    });
    return dialogRef;
  }

  onCaptureDocumentClicked(appointment) {
    this.triggerDocumentUploadWithDepartment();
  }

  onSendOrFillFormClicked(event: any) {
    // TODO: open


    var obj = {
      patient: {
        ID: this.customer.ID,
        Name: this.customer.Name,
        Email: this.customer.Email
      },
      branchID: null
    }


    // open dialog
    const dialogRef = this.dialog.open(SendFormDialogComponent, {
      width: '380px',
      panelClass: 'custom-panel-dialog',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: obj
    });


    dialogRef.afterClosed().subscribe(resultData => {

      if (resultData) {
        if (resultData.result === FormsService.SEND_TO_CUSTOMER) {
          this.formService.data = resultData;
          this.router.navigate(['/select-form']);
        }
        else if (resultData.result === FormsService.FILL_BY_THERAPIST) {
          this.formService.data = resultData;
          this.router.navigate(['/select-form']);
        }
        else {
          this.formService.data = {};
        }
      }
      else {
        this.formService.data = {};
      }
    });

  }


  onUploadImage(event:any){   
    this.uploadType = FileUploadType.Image;
    this.triggerImageUploadWithDepartment(event); // this will trigger onFileChange after selecting depatment
  }

  onUploadDocument(event:any){
    this.uploadType = FileUploadType.Document;
    this.onFileChange(event);
  }



  onFileChange(event: any) {    
    var fileChangeEvent = event;
    var customerID = this.customerID;
    var departmentID = this.uploadDepartmentID;
    
    const dialogRef = this.dialog.open(UploadProgressComponent, {
      width: '300px',
      direction: (this.settings.rtl ? 'rtl' : null),
      disableClose: true,
      data: {
        customerID: customerID,
        departmentID: departmentID,
        event: fileChangeEvent,
        uploadType: this.uploadType
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {      
      this.uploadDepartmentID = ''; // reset   
      if(this.uploadType == FileUploadType.Image){
        this.clearImageFiles(fileChangeEvent);
      }        
      
    });
  }

  showDialogForEnableCameraPermission() {
    let msg = this.translate.instant(`MSG.ALLOW-PERMISSIONS-TO-CAMERA`);

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        buttons: [
          {
            name: 'ok',
            text: this.translate.instant('COMMON.OK'),
            color: 'accent',
            width: '100%'
          }
        ]

      }
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult === 'ok') {

      }
    });


  }


}
